// Libraries
import { Box, CardMedia, Typography } from "@material-ui/core";
import { useObserver } from "mobx-react-lite";
import React from "react";

// Custom
import DiagramDelcoteDelglazeImage from "Custom/Content/ProductSelector/diagram_delcote_delglaze.png";

import { EditVariants } from "Custom/StylesAppSpecific/EditVariants";
import { TypographyVariants } from "Custom/StylesAppSpecific/TypographyVariants";
import { DelcoteAsbestosStyle } from "./DelcoteAsbestosStyle";

import { ProductsCommonViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/RoofSystemSubViewModels/ProductsCommonViewModel";
import { DelglazeViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/RoofSystemSubViewModels/DelglazeViewModel";
import { DelcoteAsbestosViewModel } from "Custom/ViewModels/ProductSelector/SubViewModels/RoofSystemSubViewModels/DelcoteProductsViewModels/DelcoteAsbestosViewModel";
import { Delglaze } from "./../Delglaze";
import { BQSEditNumber } from "Custom/Views/Primitives/Edits/BQSEditNumber";
import { BQSRow } from "Custom/Views/Primitives/Row/BQSRow";
import { BQSSelect } from "Custom/Views/Primitives/Selects/BQSSelect";

interface IProps {
    className?: string;
    commonViewModel: ProductsCommonViewModel;
    delglazeViewModel: DelglazeViewModel;
    viewModel: DelcoteAsbestosViewModel;
}

export const DelcoteAsbestos: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind

    const editVariants = EditVariants();
    const typopgraphyVariants = TypographyVariants();
    const delcoteAsbestosStyle = DelcoteAsbestosStyle();

    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Box className={delcoteAsbestosStyle.root}>
            <BQSRow>
                <Box>
                    <Typography className={typopgraphyVariants.productSelectorh2} variant="h2">
                        Delcote full roof coating system
                    </Typography>
                    <CardMedia className={delcoteAsbestosStyle.delcotedelglazeimage} image={DiagramDelcoteDelglazeImage} title="Roof coating" />
                </Box>
                <Box>
                    <BQSRow className={delcoteAsbestosStyle.editsContainer}>
                        <BQSEditNumber
                            className={editVariants.bqsEditNumberStandard}
                            displayName="m<sup>2</sup> of roof to coat"
                            execute={props.commonViewModel.setRoofSquareMeterage}
                            minimumValue={0}
                            startAdornment={`<div class="${editVariants.bqsKeyAAdornment}"></div>`}
                            value={props.viewModel.roofSquareMeterage}
                        />
                        <BQSEditNumber
                            className={editVariants.bqsEditNumberStandard}
                            displayName="m<sup>2</sup> of roof lights"
                            execute={props.commonViewModel.setRooflightSquareMeterage}
                            minimumValue={0}
                            startAdornment={`<div class="${editVariants.bqsKeyBAdornment}"></div>`}
                            value={props.viewModel.rooflightSquareMeterage}
                        />
                        {/*                         <BQSEditNumber
                            className={editVariants.bqsEditNumberReadOnly}
                            canExecute={false}
                            displayName="Net m<sup>2</sup>"
                            endAdornment={`<div class="${editVariants.bqsSuperScriptAdornment}">m<sup>2</sup></div>`}
                            execute={() => {}}
                            validationMessage={props.viewModel.netRoofSquareMeterageValidationMessage}
                            value={props.viewModel.netRoofSquareMeterage}
                        /> */}
                    </BQSRow>
                    <Box className={delcoteAsbestosStyle.textContainer}>
                        <Typography variant="body2">
                            All measurements in this calculator should be inputted as linear (end to end) not including the roof profile. The area of the roof will be increased
                            using the profile correction entered in the field below.
                        </Typography>
                    </Box>
                    <BQSRow className={delcoteAsbestosStyle.editsContainer}>
                        <BQSEditNumber
                            className={editVariants.bqsEditNumberFlex}
                            displayName="Profile correction"
                            endAdornment="%"
                            execute={props.commonViewModel.setProfileCorrectionPercentage}
                            minimumValue={0}
                            value={props.viewModel.profileCorrectionPercentage}
                        />
                    </BQSRow>
                    <BQSRow className={delcoteAsbestosStyle.editsContainer}>
                        <BQSEditNumber
                            className={editVariants.bqsEditNumberFlex}
                            displayName="If the fixings are remaining in-situ, enter the number below"
                            execute={props.commonViewModel.setFixingCount}
                            minimumValue={0}
                            value={props.viewModel.fixingCount}
                        />
                    </BQSRow>

                    <BQSRow className={delcoteAsbestosStyle.selectContainer}>
                        <BQSSelect
                            disableClearable={true}
                            displayName="Which topcoat colour option do you require?"
                            execute={props.commonViewModel.setDelcoteTopcoatColour}
                            getOptionLabel={(option) => option.title}
                            groupBy={(option) => option.group}
                            options={props.viewModel.topcoatColours}
                            value={props.viewModel.topcoatColourSelection}
                            validationMessage={props.viewModel.colourValidationMessage}
                            showColourLink={true}
                        />
                    </BQSRow>
                    <Delglaze commonViewModel={props.commonViewModel} viewModel={props.delglazeViewModel} />
                </Box>
            </BQSRow>
        </Box>
    ));

    // #endregion Render Result
};
